<template>
    <b-btn :variant="activateNotification ? 'secondary' : 'success'"
           class="rounded-circle"
           @click="checkNotification"
           v-b-tooltip
           :title="activateNotification ? 'غیر فعال کردن نوتیفیکیشن' : 'فعال کردن نوتیفیکیشن'"
    >
        <font-awesome-icon icon="bell" class="align-middle"/>
    </b-btn>
</template>

<script>
    export default {
        name: "pushNotification",
        data () {
            return {
                activateNotification: false
            }
        },
        mounted() {
            this.getNotificationPermissionState().then(res => {
                if (res === 'granted') {
                    this.activateNotification = true
                }
            })
        },
        methods: {
            checkNotification () {
                this.getNotificationPermissionState().then(res => {
                    if (res !== 'granted') {
                        Notification.requestPermission().then(req => {
                            return;
                        })
                    }
                    else {
                        this.activateNotification = true
                    }
                    // else {
                    //     navigator.serviceWorker.ready.then(registration => {
                    //         registration.showNotification('test', {
                    //             body : 'این یک نوتیفیکیشن تستی است'
                    //         })
                    //     })
                    // }
                    this.getSubscription().then(subscriptionArrive => {
                        console.log(subscriptionArrive)
                        if (subscriptionArrive === null) {
                            this.getPushSubscription().then(pushSb => {
                                console.log(pushSb)
                            }).catch(err => {

                            })
                        } else {
                            subscriptionArrive.unsubscribe()
                        }
                    })
                })
            },
            getNotificationPermissionState () {
                if (navigator.permissions) {
                    return navigator.permissions.query({name: 'notifications'}).then(res => {
                        console.log(res.state)
                        return res.state
                    })
                }
            },
            getSubscription () {
                return navigator.serviceWorker.ready.then(res => {
                    return res.pushManager.getSubscription()
                })
            },
            getPushSubscription () {
                navigator.serviceWorker.ready.then(res => {
                    let sb = {
                        userVisibleOnly : true,
                        applicationServerKey : this.urlBase64ToUint8Array('BJ-rYrpYj4y7hR4UEvnkiSQj1yugjsvbf5pBIX_dYBG2y2Lg69i1OiXPvjLCK0ysm2n9kbN5tpvzL0gUgRjN1FA')
                    }
                    console.log(sb)
                    console.log(res.pushManager.subscribe(sb))
                })
            },
            urlBase64ToUint8Array (base64String) {
                const padding = '='.repeat((4 - base64String.length % 4) % 4);
                const base64 = (base64String + padding)
                    .replace(/\-/g, '+')
                    .replace(/_/g, '/');

                const rawData = window.atob(base64);
                const outputArray = new Uint8Array(rawData.length);

                for (let i = 0; i < rawData.length; ++i) {
                    outputArray[i] = rawData.charCodeAt(i);
                }
                return outputArray;
            },
        }
    }
</script>

<style scoped>

</style>